<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="modal fade" id="costumModalpeta" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
            aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
            style="background: rgba(240, 248, 255, 0.1);width: 95vw;height: 98%;">
            <div class="modal-dialog modal-fullscreen">
                <div class="modal-content" style="height: auto;min-width: 90vw; min-height: 98%;">
                    <div class="modal-header">
                        <h4 class="modal-title">Mapping Paket iemon</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-justify" style="height: auto;min-width: 90vw; min-height: 98%;">
                        <p>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="card cardputih collapsed-card">
                                    <div class="card-header border-transparent bg-yellow" data-card-widget="collapse"
                                        style="cursor: pointer;">
                                        <label>Show / Hide Kolom</label>
                                        <div class="card-tools">
                                            <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                                <i class="fas fa-plus" style="color: black;"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="card-body px-3" style="font-size: smaller !important;">
                                        <div class="row">
                                            <div class="col-sm-1">
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input custom-control-input-warning"
                                                        type="checkbox" id="customCheckboxOpsi" value="optionOpsi"
                                                        checked @click="showNo = !showNo">
                                                    <label for="customCheckboxOpsi" class="custom-control-label">
                                                        No
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-sm-1">
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input custom-control-input-warning"
                                                        type="checkbox" id="customCheckboxTipe" value="optionTipe"
                                                        checked @click="showKode = !showKode">
                                                    <label for="customCheckboxTipe" class="custom-control-label">
                                                        Kode
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-sm-1">
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input custom-control-input-warning"
                                                        type="checkbox" id="customCheckboxKode" value="optionKode"
                                                        checked @click="showKegiatan = !showKegiatan">
                                                    <label for="customCheckboxKode" class="custom-control-label">
                                                        Kegiatan
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-sm-1">
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input custom-control-input-warning"
                                                        type="checkbox" id="customCheckboxVolume" value="optionVolume"
                                                        @click="showVolume = !showVolume">
                                                    <label for="customCheckboxVolume" class="custom-control-label">
                                                        Volume
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-sm-1">
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input custom-control-input-warning"
                                                        type="checkbox" id="customCheckboxSatuan" value="optionSatuan"
                                                        @click="showSatuan = !showSatuan">
                                                    <label for="customCheckboxSatuan" class="custom-control-label">
                                                        Satuan
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-sm-1">
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input custom-control-input-warning"
                                                        type="checkbox" id="customCheckboxLokasi" value="optionLokasi"
                                                        @click="showLokasi = !showLokasi">
                                                    <label for="customCheckboxLokasi" class="custom-control-label">
                                                        Lokasi
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-sm-1">
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input custom-control-input-warning"
                                                        type="checkbox" id="customCheckboxJenisPaket"
                                                        value="optionJenisPaket"
                                                        @click="showJenisPaket = !showJenisPaket">
                                                    <label for="customCheckboxJenisPaket" class="custom-control-label">
                                                        Jenis Paket
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-sm-1">
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input custom-control-input-warning"
                                                        type="checkbox" id="customCheckboxMetode" value="optionMetode"
                                                        @click="showMetode = !showMetode">
                                                    <label for="customCheckboxMetode" class="custom-control-label">
                                                        Metode
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-sm-1">
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input custom-control-input-warning"
                                                        type="checkbox" id="customCheckboxSumberDana"
                                                        value="optionSumberDana"
                                                        @click="showSumberDana = !showSumberDana">
                                                    <label for="customCheckboxSumberDana" class="custom-control-label">
                                                        Sumber Dana
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-sm-1">
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input custom-control-input-warning"
                                                        type="checkbox" id="customCheckboxPagu" value="optionPagu"
                                                        checked @click="showPagu = !showPagu">
                                                    <label for="customCheckboxPagu" class="custom-control-label">
                                                        Pagu
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-sm-1">
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input custom-control-input-warning"
                                                        type="checkbox" id="customCheckboxRealisasi"
                                                        value="optionRealisasi" checked
                                                        @click="showRealisasi = !showRealisasi">
                                                    <label for="customCheckboxRealisasi" class="custom-control-label">
                                                        Realisasi
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-sm-1">
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input custom-control-input-warning"
                                                        type="checkbox" id="customCheckboxKeu" value="optionKeu" checked
                                                        @click="showKeu = !showKeu">
                                                    <label for="customCheckboxKeu" class="custom-control-label">
                                                        Keu.
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-sm-1">
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input custom-control-input-warning"
                                                        type="checkbox" id="customCheckboxFisik" value="optionFisik"
                                                        checked @click="showFisik = !showFisik">
                                                    <label for="customCheckboxFisik" class="custom-control-label">
                                                        Fisik
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-sm-1">
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input custom-control-input-warning"
                                                        type="checkbox" id="customCheckboxPaguE" value="optionPaguE"
                                                        checked @click="showPaguE = !showPaguE">
                                                    <label for="customCheckboxPaguE" class="custom-control-label">
                                                        DIPA
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-sm-1">
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input custom-control-input-warning"
                                                        type="checkbox" id="customCheckboxKeuE" value="optionKeuE"
                                                        checked @click="showKeuE = !showKeuE">
                                                    <label for="customCheckboxKeuE" class="custom-control-label">
                                                        SPM / SP2D
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-sm-1">
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input custom-control-input-warning"
                                                        type="checkbox" id="customCheckboxFisikE" value="optionFisikE"
                                                        checked @click="showFisikE = !showFisikE">
                                                    <label for="customCheckboxFisikE" class="custom-control-label">
                                                        Reksus
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldata" style="font-size: x-small;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;" v-if="showNo">No</th>
                                                <th style="width: 50px;" v-if="showKode">Kode</th>
                                                <th style="width: 200px;" v-if="showKegiatan">Kegiatan/KRO/RO/Paket</th>
                                                <th style="width: 50px;" v-if="showVolume">Target<br>Volume</th>
                                                <th style="width: 50px;" v-if="showSatuan">Satuan</th>
                                                <th style="width: 50px;" v-if="showLokasi">Lokasi</th>
                                                <th style="width: 50px;" v-if="showJenisPaket">Jenis Paket</th>
                                                <th style="width: 50px;" v-if="showMetode">Metode Pemilihan</th>
                                                <th style="width: 10px;" v-if="showSumberDana">Sumber Dana</th>
                                                <th style="width: 50px;" v-if="showPagu">Pagu<br>(Rp Ribu)</th>
                                                <th style="width: 50px;" v-if="showRealisasi">Realisasi<br>(Rp Ribu)
                                                </th>
                                                <th style="width: 50px;" v-if="showKeu">Keu.<br>(%)</th>
                                                <th style="width: 50px;" v-if="showFisik">Fisik<br>(%)</th>
                                            </tr>
                                        </thead>
                                        <template v-for="(datalist, urutlist) in dataemon" :key="urutlist">
                                            <tbody>
                                                <tr>
                                                    <td class="text-center" :class="datalist.class" v-if="showNo">
                                                        <span v-if="urutlist > 0 && datalist.class == 'akhirbaru'">
                                                            <input type="checkbox"
                                                                :checked="kodeemon.includes(datalist.kdgiat)"
                                                                @click="cekarray(datalist.kdgiat, datalist.nmgiat)"
                                                                :id="datalist.kdgiat">
                                                        </span>
                                                    </td>
                                                    <td class="text-left" :class="datalist.class" v-if="showKode">
                                                        {{ datalist.kdgiat }}
                                                    </td>
                                                    <td class="text-left" :class="datalist.class" v-if="showKegiatan">
                                                        {{ datalist.nmgiat }}
                                                    </td>
                                                    <td class="text-center" :class="datalist.class" v-if="showVolume"
                                                        data-z="#,##0">
                                                        {{ G_numFormat(datalist.vol) }}
                                                    </td>
                                                    <td class="text-left" :class="datalist.class" v-if="showSatuan">
                                                        {{ datalist.satuan }}
                                                    </td>
                                                    <td class="text-left" :class="datalist.class" v-if="showLokasi">
                                                        {{ datalist.kabkota }}<br>{{ datalist.lokasi }}
                                                    </td>
                                                    <td class="text-left" :class="datalist.class" v-if="showJenisPaket">
                                                        {{ datalist.kategori }}
                                                    </td>
                                                    <td class="text-left" :class="datalist.class" v-if="showMetode">
                                                        {{ datalist.metode }}
                                                    </td>
                                                    <td class="text-center" :class="datalist.class"
                                                        v-if="showSumberDana">
                                                        {{ datalist.sumber_dana }}
                                                    </td>
                                                    <td class="text-right" :class="datalist.class" v-if="showPagu"
                                                        data-z="#,##0" :data-v="datalist.pagu">
                                                        {{ G_numFormat(datalist.pagu) }}
                                                    </td>
                                                    <td class="text-right" :class="datalist.class" v-if="showRealisasi"
                                                        data-z="#,##0" :data-v="datalist.realisasi">
                                                        {{ G_numFormat(datalist.realisasi) }}
                                                    </td>
                                                    <td class="text-right" :class="datalist.class" v-if="showKeu"
                                                        data-z="#,##0.00" :data-v="datalist.persenkeu">
                                                        {{ G_numFormatKoma(datalist.persenkeu) }}
                                                    </td>
                                                    <td class="text-right" :class="datalist.class" v-if="showFisik"
                                                        data-z="#,##0.00" :data-v="datalist.persenfisik">
                                                        {{ G_numFormatKoma(datalist.persenfisik) }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                        <tbody v-if="(datapesan == 'data kosong')">
                                            <tr>
                                                <td colspan="8">Data masih kosong</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-sm-12">&nbsp;</div>
                        </div>
                        </p>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-success3 btn-sm lebar2 text-white"
                            @click="simpanmapping()"><i class="fas fa-plus-square"></i>
                            Simpan</button>
                        <button type="button" class="btn btn-danger3 btn-sm lebar2 text-white" data-dismiss="modal"> <i
                                class="far fa-times-circle"></i>
                            Batal</button>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>FINANCE</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">HOME </a></li>
                                <li class="breadcrumb-item active">FINANCE</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12  wow fadeInDown" v-if="(roleuser == 'admin')" style="display: none;">
                            <div class="card collapsed-card">
                                <div class="card-header border-transparent" data-card-widget="collapse"
                                    style="cursor: pointer;">
                                    <label>Import Data Excel</label>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="col-sm-12">
                                        <div class="col-sm-12 text-center">
                                            <a class="hitam">
                                                <button type="button" class="btn btn-success btn-sm text-white lebar2"
                                                    data-toggle="tooltip" data-placement="left"
                                                    title="Unduh master excel.." @click="G_tableCSV('_Monev_')">
                                                    <i class="fas fa-download"></i> Unduh Master Data Monev .xlsx
                                                </button>
                                            </a>
                                        </div>
                                        <!--IKON PETA 1-->
                                        <div class="col-sm-12">
                                            <label>Pilih File<small class="text-info"> (*.xlsx)</small>
                                            </label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="far fa-file-image"></i></span>
                                                </div>
                                                <input type="file" class="form-control form-control-sm"
                                                    id="fileToUploadfilenya_excel" name="fileToUploadfilenya_excel"
                                                    placeholder="fileToUpload" style="font-size: smaller;"
                                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                    @change="onChange">
                                                <input type="hidden" class="form-control form-control-sm"
                                                    id="filenya_excel" name="filenya_excel" placeholder="File Excel">
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Opsi</label>
                                            <div class="row">
                                                <div class="col-sm-10">
                                                    <div class="progress">
                                                        <div class="progress-bar" role="progressbar" aria-valuenow="0"
                                                            aria-valuemin="0" aria-valuemax="100" style="width:0%"
                                                            id="persennyafilenya_excel">
                                                            <span id="tulisanpersenfilenya_excel">0%</span>
                                                        </div>
                                                    </div>
                                                    <br>
                                                    <span class="text-success" id="suksesnyafilenya_excel"></span>
                                                </div>
                                                <div class="col-sm-2 text-center" v-if="tempjumlah > 0">
                                                    <button type="button"
                                                        class="btn btn-warning btn-sm lebar text-white"
                                                        @click="uploadsavedata()">
                                                        Simpan ke DB
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <!--IKON PETA 1 END-->
                                        <div class="col-sm-12">
                                            Jumlah Data excel siap Import: {{ tempjumlah }}
                                            <span style="float: right;">Jumlah Data excel Tersimpan di DB: {{
                                                tempjumlahdb
                                                }}</span>
                                            <div class="table-responsive table-wrapper" v-if="tempjumlah > 0">
                                                <table class="table m-0" id="tabeldata2">
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                Urut
                                                            </th>
                                                            <template v-for="(dataheader, urutheader) in tempheader"
                                                                :key="urutheader">
                                                                <th>
                                                                    {{ dataheader }}
                                                                </th>
                                                            </template>
                                                        </tr>
                                                    </thead>
                                                    <template v-for="(datadata, urutdata) in tempdata" :key="urutdata">
                                                        <tr>
                                                            <td>{{ urutdata + 1 }}</td>
                                                            <td v-for="(isidata, urutisi) in datadata" :key="urutisi">
                                                                {{ isidata }}
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih collapsed-card">
                                <div class="card-header border-transparent" data-card-widget="collapse"
                                    style="cursor: pointer;">
                                    <label>Filter Kolom</label>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body px-3">
                                    <div class="row">
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxStatusKegiatan"
                                                    value="optionStatusKegiatan"
                                                    @click="showColumnStatusKegiatan = !showColumnStatusKegiatan">
                                                <label for="customCheckboxStatusKegiatan" class="custom-control-label">
                                                    Status Kegiatan</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxOuput" value="optionOuput"
                                                    @click="showColumnOuput = !showColumnOuput">
                                                <label for="customCheckboxOuput" class="custom-control-label">
                                                    Komponen</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxSubKomponen"
                                                    value="optionSubKomponen"
                                                    @click="showColumnSubKomponen = !showColumnSubKomponen">
                                                <label for="customCheckboxSubKomponen" class="custom-control-label">
                                                    Sub Komponen</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxOWP" value="optionOWP"
                                                    @click="showColumnOWP = !showColumnOWP" checked>
                                                <label for="customCheckboxOWP" class="custom-control-label">
                                                    OWP</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxTotalAWP" value="optionTotalAWP"
                                                    @click="showColumnTotalAWP = !showColumnTotalAWP">
                                                <label for="customCheckboxTotalAWP" class="custom-control-label">
                                                    Total AWP</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxAWP" value="optionAWP"
                                                    @click="showColumnAWP = !showColumnAWP">
                                                <label for="customCheckboxAWP" class="custom-control-label">
                                                    AWP</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxTotalDIPA" value="optionTotalDIPA"
                                                    @click="showColumnTotalDIPA = !showColumnTotalDIPA">
                                                <label for="customCheckboxTotalDIPA" class="custom-control-label">
                                                    Total DIPA</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxDIPA" value="optionDIPA"
                                                    @click="showColumnDIPA = !showColumnDIPA">
                                                <label for="customCheckboxDIPA" class="custom-control-label">
                                                    DIPA</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxPHOFHO" value="optionPHOFHO"
                                                    @click="showColumnPHOFHO = !showColumnPHOFHO">
                                                <label for="customCheckboxPHOFHO" class="custom-control-label">
                                                    PHO / FHO</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxPenyedia" value="optionPenyedia"
                                                    @click="showColumnPenyedia = !showColumnPenyedia">
                                                <label for="customCheckboxPenyedia" class="custom-control-label">
                                                    Penyedia</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxMulai" value="optionMulai"
                                                    @click="showColumnMulai = !showColumnMulai">
                                                <label for="customCheckboxMulai" class="custom-control-label">
                                                    Mulai</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxSelesai" value="optionSelesai"
                                                    @click="showColumnSelesai = !showColumnSelesai">
                                                <label for="customCheckboxSelesai" class="custom-control-label">
                                                    Selesai</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxDurasi" value="optionDurasi"
                                                    @click="showColumnDurasi = !showColumnDurasi">
                                                <label for="customCheckboxDurasi" class="custom-control-label">
                                                    Durasi</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxKontrak" value="optionKontrak"
                                                    @click="showColumnKontrak = !showColumnKontrak">
                                                <label for="customCheckboxKontrak" class="custom-control-label">
                                                    No Kontrak</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxAdendum" value="optionAdendum"
                                                    @click="showColumnAdendum = !showColumnAdendum">
                                                <label for="customCheckboxAdendum" class="custom-control-label">
                                                    Adendum</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxBerjalan" value="optionBerjalan"
                                                    @click="showColumnBerjalan = !showColumnBerjalan">
                                                <label for="customCheckboxBerjalan" class="custom-control-label">
                                                    Durasi Berjalan</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxTersisa" value="optionTersisa"
                                                    @click="showColumnTersisa = !showColumnTersisa">
                                                <label for="customCheckboxTersisa" class="custom-control-label">
                                                    Durasi Tersisa</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxCapaian" value="optionCapaian"
                                                    @click="showColumnCapaian = !showColumnCapaian">
                                                <label for="customCheckboxCapaian" class="custom-control-label">
                                                    Capaian</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxKeterangan"
                                                    value="optionKeterangan"
                                                    @click="showColumnKeterangan = !showColumnKeterangan">
                                                <label for="customCheckboxKeterangan" class="custom-control-label">
                                                    Keterangan</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxLatitude" value="optionLatitude"
                                                    @click="showColumnLatitude = !showColumnLatitude">
                                                <label for="customCheckboxLatitude" class="custom-control-label">
                                                    Latitude</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxLongitude" value="optionLongitude"
                                                    @click="showColumnLongitude = !showColumnLongitude">
                                                <label for="customCheckboxLongitude" class="custom-control-label">
                                                    Longitude</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih collapsed-card">
                                <div class="card-header border-transparent" data-card-widget="collapse"
                                    style="cursor: pointer;">
                                    <label>
                                        Filter Data
                                    </label>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body px-3">
                                    <div class="row">
                                        <div class="col-sm-3 text-center">
                                            <label>PIU</label>
                                            <v-select :options="id_user" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedid_user" @update:modelValue="onid_userChange"
                                                style="background-color: #ffffff;"></v-select>
                                        </div>
                                        <div class="col-sm-3 text-center">
                                            <label>
                                                Jenis Kegiatan
                                            </label>
                                            <v-select :options="jenispekerjaan2" :reduce="(label) => label.code"
                                                label="label" v-model="defaultSelectedjenispekerjaan2"
                                                @update:modelValue="onjenispekerjaan2Change"
                                                style="background-color: #ffffff;color: black;"></v-select>
                                        </div>
                                        <div class="col-sm-3 text-center">
                                            <label>
                                                Tahun
                                            </label>
                                            <v-select :options="tahunmulai2" :reduce="(label) => label.code"
                                                label="label" v-model="defaultSelectedtahunmulai2"
                                                @update:modelValue="ontahunmulai2Change"
                                                style="background-color: #ffffff;color: black;"></v-select>
                                        </div>
                                        <div class="col-sm-3 text-center">
                                            <label>
                                                Lokasi
                                            </label>
                                            <v-select :options="lokasi" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedlokasi" @update:modelValue="onlokasiChange"
                                                style="background-color: #ffffff;color: black;"></v-select>
                                        </div>
                                        <div class="col-sm-3 text-center">
                                            <label>
                                                Komponen
                                            </label>
                                            <v-select :options="komponen" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedkomponen" @update:modelValue="onkomponenChange"
                                                style="background-color: #ffffff;color: black;"></v-select>
                                        </div>
                                        <div class="col-sm-3 text-center">
                                            <label>
                                                Sub Komponen
                                            </label>
                                            <v-select :options="subkomponen" :reduce="(label) => label.code"
                                                label="label" v-model="defaultSelectedsubkomponen"
                                                @update:modelValue="onsubkomponenChange"
                                                style="background-color: #ffffff;color: black;"></v-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih">
                                <div class="card-header border-transparent">
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                    <div class="col-sm-12 float-left pb-2 px-3 wow fadeInDown">
                                        Jumlah Data {{ G_numFormat(jumlahdata) }}
                                        <span style="float: right;display: none;">
                                            <span>Halaman ke: </span>
                                            <select v-model="halaman" @change="onChangeHalaman($event)">
                                                <option v-for="index in jumlahhalaman" :key="index">
                                                    {{ index }}</option>
                                            </select>
                                            <span> dari </span> {{ jumlahhalaman }}
                                        </span>
                                    </div>
                                    <div class="col-sm-12 float-left pb-2">
                                        <input type="text" v-model="carikata" class="form-control form-control-sm"
                                            placeholder="Masukkan Kata Kunci Pencarian" @keyup="ambildatakata()">
                                    </div>
                                </div>
                                <div class="card-body p-0">
                                    <div class="table-responsive table-wrapper">
                                        <table class="table m-0" id="tabeldata" style="font-size: x-small !important;">
                                            <thead>
                                                <tr>
                                                    <th style="width: 50px;" rowspan="2">No</th>
                                                    <th style="width: 100px;" rowspan="2">Opsi</th>
                                                    <th style="width: 150px;" rowspan="2">PIU / Satker</th>
                                                    <th style="width: 150px;" rowspan="2">Kegiatan</th>
                                                    <th style="width: 50px;" rowspan="2">Mapping<br></br>Paket iemon
                                                    </th>
                                                    <th style="width: 150px;" rowspan="2">Paket iemon
                                                    </th>
                                                    <th style="width: 50px;" rowspan="2">Mapping<br></br>DIPA</th>
                                                    <th style="width: 50px;" rowspan="2">Mapping<br></br>SPM</th>
                                                    <th style="width: 100px;" rowspan="2"
                                                        v-if="showColumnStatusKegiatan">
                                                        Status<br>Kegiatan
                                                    </th>
                                                    <th style="width: 50px;" rowspan="2" v-if="showColumnOuput">Komponen
                                                    </th>
                                                    <th style="width: 50px;" rowspan="2" v-if="showColumnSubKomponen">
                                                        Sub Komponen
                                                    </th>
                                                    <th style="width: 50px;" rowspan="2" v-if="showColumnPHOFHO">
                                                        Status<br>PHO/FHO</th>
                                                    <th style="width: 50px;" rowspan="2" v-if="showColumnPHOFHO">
                                                        Tanggal<br>PHO/FHO</th>
                                                    <th style="width: 50px;" rowspan="2" v-if="showColumnOWP">
                                                        OWP<br>(Rp.)</th>
                                                    <th style="width: 50px;" rowspan="2" v-if="showColumnTotalAWP">
                                                        Total<br>AWP<br>(Rp.)</th>
                                                    <th style="width: 50px;" :colspan="colspan" v-if="showColumnAWP">
                                                        AWP<br>Tahun (Rp.)</th>
                                                    <th style="width: 50px;" rowspan="2" v-if="showColumnTotalDIPA">
                                                        Total<br>DIPA<br>(Rp.)</th>
                                                    <th style="width: 50px;" :colspan="colspan" v-if="showColumnDIPA">
                                                        DIPA<br>Tahun (Rp.)</th>
                                                    <th style="width: 50px;" rowspan="2">
                                                        Realisasi<br>Keuangan<br>Kumulatif<br>(Rp.)</th>
                                                    <th style="width: 50px;" rowspan="2">Progres<br>Keuangan (%)</th>
                                                    <th style="width: 50px;" rowspan="2">
                                                        Status<br>Penyerapan<br>Anggaran</th>
                                                    <th style="width: 50px;" rowspan="2" v-if="showColumnPenyedia">
                                                        Penyedia</th>
                                                    <th style="width: 50px;" rowspan="2" v-if="showColumnMulai">Mulai
                                                    </th>
                                                    <th style="width: 50px;" rowspan="2" v-if="showColumnSelesai">
                                                        Selesai</th>
                                                    <th style="width: 50px;" rowspan="2" v-if="showColumnDurasi">
                                                        Durasi<br>(Bulan)</th>
                                                    <th style="width: 50px;" rowspan="2" v-if="showColumnKontrak">Nomor
                                                        Kontrak</th>
                                                    <th style="width: 50px;" rowspan="2" v-if="showColumnAdendum">
                                                        Adendum</th>
                                                    <th style="width: 50px;" rowspan="2">Nilai Kontrak<br>(Rp.)</th>
                                                    <th style="width: 50px;" rowspan="2" v-if="showColumnBerjalan">
                                                        Waktu<br>Durasi<br>Berjalan<br>(%)</th>
                                                    <th style="width: 50px;" rowspan="2" v-if="showColumnTersisa">
                                                        Waktu<br>Durasi<br>Tersisa<br>(%)</th>
                                                    <th style="width: 50px;" rowspan="2" v-if="showColumnCapaian">
                                                        Capaian<br>(%)</th>
                                                    <th style="width: 50px;" rowspan="2" v-if="showColumnKeterangan">
                                                        Keterangan</th>
                                                    <th style="width: 50px;" rowspan="2" v-if="showColumnLatitude">
                                                        Latitude</th>
                                                    <th style="width: 50px;" rowspan="2" v-if="showColumnLongitude">
                                                        Longitude</th>
                                                </tr>
                                                <tr>
                                                    <th v-if="showColumnAWP"
                                                        v-for="(listtahun, uruttahun) in datatahun">{{
                                                            listtahun }}</th>
                                                    <th v-if="showColumnDIPA"
                                                        v-for="(listtahun, uruttahun) in datatahun">{{
                                                            listtahun }}</th>
                                                </tr>
                                            </thead>
                                            <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                                                <tbody>
                                                    <tr>
                                                        <td :class="datalist.class">{{ urutlist + 1 }}</td>
                                                        <td :class="datalist.class" class="text-center">
                                                            <button type="button" style="width: 90px;"
                                                                class="btn btn-primary3 btn-sm text-white"
                                                                @click="mappingemon(datalist.id, datalist.kdsatker, datalist.register)"
                                                                data-toggle="tooltip" data-placement="left"
                                                                title="Mapping Paket.."><i
                                                                    class="fas fa-chart-line"></i>
                                                                Mapping Paket
                                                            </button>
                                                            <button type="button" style="width: 90px;"
                                                                class="btn btn-warning btn-sm text-white"
                                                                @click="prosesdata(datalist.id)" data-toggle="tooltip"
                                                                data-placement="left" title="DIPA.."><i
                                                                    class="fas fa-edit"></i> DIPA
                                                            </button>
                                                            <button type="button" style="width: 90px;"
                                                                class="btn btn-success btn-sm text-white"
                                                                @click="prosesspm(datalist.id)"
                                                                data-toggle="tooltip" data-placement="left"
                                                                title="button data.."><i
                                                                    class="fas fa-balance-scale"></i>
                                                                SPM
                                                            </button>
                                                        </td>
                                                        <td :class="datalist.class">
                                                            {{ datalist.nama_satker }}<br>
                                                            </br><span class="text-info">{{ datalist.nama_satkeremon
                                                                }}</span>
                                                        </td>
                                                        <td :class="datalist.class">
                                                            <span v-html="datalist.Nama_Kegiatan"></span>
                                                        </td>
                                                        <td :class="datalist.classmapping" class="text-center">
                                                            {{ datalist.jumlahmapping }}
                                                        </td>
                                                        <td :class="datalist.classmapping">
                                                            <span class="text-success" v-html="Dekriptext(datalist.namapaketmapping)"></span>
                                                        </td>
                                                        <td :class="datalist.classdipa" class="text-right">
                                                            {{ G_numFormat(datalist.jumlahdipa) }}
                                                        </td>
                                                        <td :class="datalist.classspm" class="text-center">
                                                            {{ G_numFormat(datalist.jumlahspm) }}
                                                        </td>
                                                        <td :class="datalist.class" v-if="showColumnStatusKegiatan">
                                                            {{ datalist.Status_pekerjaan }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-center"
                                                            v-if="showColumnOuput">
                                                            {{ datalist.Komponen }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-center"
                                                            v-if="showColumnSubKomponen">
                                                            {{ datalist.SubKomponen }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-center"
                                                            v-if="showColumnPHOFHO">
                                                            {{ datalist.PHO_FHO }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-center"
                                                            v-if="showColumnPHOFHO">
                                                            {{ G_formatDateNonWIB(datalist.tanggalPHO_FHO) }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-right"
                                                            v-if="showColumnOWP">
                                                            {{ G_numFormat(datalist.OWP) }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-right"
                                                            v-if="showColumnTotalAWP">
                                                            {{ G_numFormat(datalist.TOTALAWP) }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-right"
                                                            v-if="showColumnAWP"
                                                            v-for="(listawp, urutawp) in datalist.AWP" :key="urutawp">
                                                            {{ G_numFormat(listawp.Nilai) }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-right"
                                                            v-if="showColumnTotalDIPA">
                                                            {{ G_numFormat(datalist.TOTALDIPA) }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-right"
                                                            v-if="showColumnDIPA"
                                                            v-for="(listdipa, urutdipa) in datalist.DIPA"
                                                            :key="urutdipa">
                                                            {{ G_numFormat(listdipa.Nilai) }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-right">
                                                            {{ G_numFormat(datalist.REALISASI_KUMULATIF) }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-center">
                                                            {{ G_numKoma(datalist.PROGRESKEUANGAN) }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-center">
                                                            {{ datalist.STATUS_KEU_PROYEK }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-justify"
                                                            v-if="showColumnPenyedia">
                                                            {{ datalist.KONTRAKTOR }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-center"
                                                            v-if="showColumnMulai">
                                                            {{ G_formatDateNonWIB(datalist.MULAI) }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-center"
                                                            v-if="showColumnSelesai">
                                                            {{ G_formatDateNonWIB(datalist.SELESAI) }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-center"
                                                            v-if="showColumnDurasi">
                                                            {{ G_numKoma(datalist.BULAN) }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-justify"
                                                            v-if="showColumnKontrak">
                                                            {{ datalist.NOKONTRAK }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-center"
                                                            v-if="showColumnAdendum">
                                                            {{ datalist.ADENDUM }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-right">
                                                            {{ G_numFormat(datalist.NILAIKONTRAK) }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-center"
                                                            v-if="showColumnBerjalan">
                                                            {{ G_numKoma(datalist.DURASI) }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-center"
                                                            v-if="showColumnTersisa">
                                                            {{ G_numKoma(datalist.DURASITERSISA) }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-center"
                                                            v-if="showColumnCapaian">
                                                            {{ G_numFormat(datalist.CAPAIAN) }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-center"
                                                            v-if="showColumnKeterangan">
                                                            {{ datalist.KETERANGAN }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-center"
                                                            v-if="showColumnLatitude">
                                                            {{ datalist.LATITUDE }}
                                                        </td>
                                                        <td :class="datalist.class" class="text-center"
                                                            v-if="showColumnLongitude">
                                                            {{ datalist.LONGITUDE }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                            <tbody v-if="(datapesan == 'data kosong')">
                                                <tr>
                                                    <label>Data masih kosong</label>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="card-footer p-3">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import xlsx from 'xlsx/dist/xlsx.full.min';
import readXlsxFile from 'read-excel-file';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal
    },
    data() {
        return {
            halamanloading: true,
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            levelinstansi: JSON.parse(localStorage.getItem("inssistem")),
            roleuser: JSON.parse(localStorage.getItem("rlsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            datapesan: '',
            datamaster: [],
            dataemon: [],
            carikata: '',
            colspan: 0,
            datatahun: [],
            showNo: true,
            showKode: true,
            showKegiatan: true,
            showSatuan: false,
            showVolume: false,
            showLokasi: false,
            showJenisPaket: false,
            showMetode: false,
            showSumberDana: false,
            showPagu: true,
            showRealisasi: true,
            showKeu: true,
            showFisik: true,
            showPaguE: true,
            showKeuE: true,
            showFisikE: true,

            showColumnStatusKegiatan: false,
            showColumnOuput: false,
            showColumnSubKomponen: false,
            showColumnPHOFHO: false,
            showColumnPenyedia: false,
            showColumnMulai: false,
            showColumnSelesai: false,
            showColumnDurasi: false,
            showColumnKontrak: false,
            showColumnAdendum: false,
            showColumnBerjalan: false,
            showColumnTersisa: false,
            showColumnOWP: true,
            showColumnTotalAWP: false,
            showColumnAWP: false,
            showColumnTotalDIPA: false,
            showColumnDIPA: false,
            showColumnCapaian: false,
            showColumnKeterangan: false,
            showColumnLatitude: false,
            showColumnLongitude: false,
            project_id: process.env.VUE_APP_PROJECT_ID,
            tempexcel: [],
            ekportexcel: [],
            jumlahdata: 0,
            jumlahhalaman: 0,
            mulai: 0,
            halaman: 1,
            jenispekerjaan2: [],
            datajenispekerjaan2: [],
            defaultSelectedjenispekerjaan2: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedjenispekerjaan2: '',

            tahunmulai2: [],
            datatahunmulai2: [],
            defaultSelectedtahunmulai2: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedtahunmulai2: '',
            komponen: [],
            datakomponen: [],
            defaultSelectedkomponen: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedkomponen: '',

            subkomponen: [],
            datasubkomponen: [],
            defaultSelectedsubkomponen: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedsubkomponen: '',
            lokasi: [],
            datalokasi: [],
            defaultSelectedlokasi: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedlokasi: '',
            id_user: [],
            dataid_user: [],
            defaultSelectedid_user: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedid_user: 0,

            halamanawal: 0,
            piuawal: 0,
            kegiatanawal: 0,
            tahunawal: 0,
            lokasiawal: 0,
            komponenawal: 0,
            subkomponenawal: 0,
            carikataawal: '',
            kodeemon: [],
            paketemon: [],
            carikodesatker: '',
            idkegiatan: '',
        }
    },
    computed: {
        filteredKataData() {
            const filteredWorkers = this.carikata === ""
                ? this.datamaster
                : this.datamaster.filter(wo => Object.values(wo).join("").toLowerCase().indexOf(this.carikata.toLowerCase()) !== -1);
            return filteredWorkers;
        },
        JumlahfilteredKataData() {
            var jumlah = 0;
            try {
                if (this.filteredKataData === undefined) {
                    jumlah = 0;
                } else {
                    jumlah = this.filteredKataData.length;
                }
            }
            catch {
                jumlah = 0;
            }
            return jumlah;
        },
    },
    methods: {
        cekarray(kode, nama) {
            //alert(document.getElementById(kode).checked);
            if (document.getElementById(kode).checked == true) {
                this.kodeemon.push(kode);
                this.paketemon.push(nama);
            }
            else {
                var valueToRemove = kode;
                var index = this.kodeemon.indexOf(valueToRemove);
                if (index !== -1) {
                    this.kodeemon.splice(index, 1); // Removes 1 element at the found index
                }

                var valueToRemovenama = nama;
                var indexnama = this.paketemon.indexOf(valueToRemovenama);
                if (indexnama !== -1) {
                    this.paketemon.splice(indexnama, 1); // Removes 1 element at the found index
                }
            }
        },
        async simpanmapping() {
            if (this.kodeemon.length == 0) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Paket iemon.',
                });
                $('.swal2-container').css("z-index", '999999');
                return false;
            }
            //alert(this.kodeemon);
            //alert(this.paketemon);
            var kodeemon = '';
            var paketemon = '';
            for (let i = 0; i < this.kodeemon.length; i++) {
                if (i == 0) {
                    kodeemon = kodeemon + this.kodeemon[i];
                    paketemon = paketemon + this.paketemon[i];
                }
                else {
                    kodeemon = kodeemon + "|" + this.kodeemon[i];
                    paketemon = paketemon + "|" + this.paketemon[i];
                }
            }
            //alert(kodeemon);
            //alert(paketemon);
            //alert(this.carikodesatker);
            //alert(this.idkegiatan);
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Simpan Mapping Kegiatan iemon?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#005c95",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Simpan"
            }).then((result) => {
                if (result.isConfirmed) {
                    var fd = new FormData();
                    fd.append("kodeemon", kodeemon);
                    fd.append("paketemon", paketemon);
                    fd.append("kodesatker", this.carikodesatker);
                    fd.append("idkegiatan", this.idkegiatan);
                    fd.append("project_id", this.project_id);
                    fd.append("createdby", JSON.parse(localStorage.getItem("isistem")));
                    const mainAPI = axios.create({
                        baseURL: process.env.VUE_APP_URL_API,
                        headers: {
                            "Content-Type": "form-data",
                            Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                        },
                    });

                    var tambahan = "_" + this.halaman + "_" + this.selectedid_user + "_" + this.selectedjenispekerjaan2 + "_" + this.selectedtahunmulai2 + "_" + this.selectedlokasi + "_" + this.selectedkomponen + "_" + this.selectedsubkomponen + "_" + this.carikata;
                    //alert(this.halaman);
                    var bytes = encodeURIComponent(CryptoJS.AES.encrypt(this.idkegiatan + tambahan, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
                    mainAPI.post("mappingkegiatanloan_emon-Add", fd).then(
                        Response => {
                            if (Response.data.response == 'error') {
                                swal.fire('Peringatan', Response.data.message, 'error');
                                $('.swal2-container').css("z-index", '999999');
                            }
                            else {
                                swal.fire('Informasi', 'Data telah ditambah..', 'success').then(function () {
                                    window.location.replace("/Finance/" + bytes);
                                });
                                $('.swal2-container').css("z-index", '999999');
                            }
                        }
                    ).catch(function (error) {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: error
                        });
                        $('.swal2-container').css("z-index", '999999');
                    }
                    )
                    return false;
                }
            });
            $('.swal2-container').css("z-index", '999999');
            return false;
        },
        ambildatakata() {
            this.carikataawal = this.carikata;
            this.ambildata();
        },
        async ambildatareff() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovationreffmonitoring-JenisPekerjaan?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.defaultSelectedjenispekerjaan2 = {
                            code: 0,
                            label: 'Semua Data',
                            tag: '',
                        };
                        this.datajenispekerjaan2 = [];
                        this.jenispekerjaan2 = [];
                        this.datajenispekerjaan2 = Response.data.content.data;
                        this.datajenispekerjaan2.forEach((item) => {
                            if (this.kegiatanawal == item.id) {
                                this.selectedjenispekerjaan2 = this.kegiatanawal;
                                this.defaultSelectedjenispekerjaan2 = {
                                    label: item.nama,
                                    code: this.datajenispekerjaan2.indexOf(item) + 1,
                                    tag: item.id,
                                };
                            }
                            this.jenispekerjaan2.push({
                                label: item.nama,
                                code: this.datajenispekerjaan2.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });

                        this.jenispekerjaan2.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationreffmonitoring-TahunProyek?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datatahunmulai2 = [];
                        this.tahunmulai2 = [];
                        this.defaultSelectedtahunmulai2 = {
                            code: 0,
                            label: 'Semua Data',
                            tag: '',
                        };
                        this.datatahunmulai2 = Response.data.content.data;
                        this.datatahunmulai2.forEach((item) => {
                            if (this.tahunawal == item.tahun) {
                                this.selectedtahunmulai2 = this.tahunawal;
                                this.defaultSelectedtahunmulai2 = {
                                    label: item.tahun,
                                    code: this.datatahunmulai2.indexOf(item) + 1,
                                    tag: item.tahun,
                                };
                            }

                            this.tahunmulai2.push({
                                label: item.tahun,
                                code: this.datatahunmulai2.indexOf(item) + 1,
                                tag: item.tahun,
                            });
                        });
                        this.tahunmulai2.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationKomponen-GetProyekKomponen?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datakomponen = [];
                        this.komponen = [];
                        this.defaultSelectedkomponen = {
                            code: 0,
                            label: 'Semua Data',
                            tag: '',
                        };

                        this.datakomponen = Response.data.content.data;

                        this.datakomponen.forEach((item) => {
                            if (this.komponenawal == item.id) {
                                this.selectedkomponen = this.komponenawal;
                                this.defaultSelectedkomponen = {
                                    label: item.nama,
                                    code: this.datakomponen.indexOf(item) + 1,
                                    tag: item.id,
                                };
                            }
                            this.komponen.push({
                                label: item.nama,
                                code: this.datakomponen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.komponen.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });

                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationSubKomponen-GetProyekSubKomponen?random=" + random + "&project_id=" + this.project_id + "&komponen=" + this.selectedkomponen).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.defaultSelectedsubkomponen = {
                            code: 0,
                            label: 'Semua Data',
                            tag: '',
                        };

                        this.datasubkomponen = [];
                        this.subkomponen = [];
                        this.datasubkomponen = Response.data.content.data;
                        this.datasubkomponen.forEach((item) => {
                            if (this.subkomponenawal == item.id) {
                                this.selectedsubkomponen = this.subkomponenawal;
                                this.defaultSelectedsubkomponen = {
                                    label: item.nama,
                                    code: this.datasubkomponen.indexOf(item) + 1,
                                    tag: item.id,
                                };
                            }
                            this.subkomponen.push({
                                label: item.nama,
                                code: this.datasubkomponen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.subkomponen.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });

                    }
                    else {
                        this.defaultSelectedsubkomponen = {
                            code: 0,
                            label: 'Semua Data',
                            tag: '',
                        };
                        this.subkomponen.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
            this.halamanloading = true;
            await mainAPI5.get("parastapainnovationreffmonitoring-Lokasi?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.defaultSelectedlokasi = {
                            code: 0,
                            label: 'Semua Data',
                            tag: '',
                        };

                        this.datalokasi = [];
                        this.lokasi = [];
                        this.datalokasi = Response.data.content.data;
                        this.datalokasi.forEach((item) => {
                            if (this.lokasiawal == item.id) {
                                this.selectedlokasi = this.lokasiawal;
                                this.defaultSelectedlokasi = {
                                    label: item.nama,
                                    code: this.datalokasi.indexOf(item) + 1,
                                    tag: item.id,
                                };
                            }
                            this.lokasi.push({
                                label: item.nama,
                                code: this.datalokasi.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.lokasi.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            this.halamanloading = true;
            const mainAPI6 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });

            var random = Math.random();
            await mainAPI6.get("parastapainnovation_userproject-GetPIU?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.levelinstansi + "&role=" + this.roleuser).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.dataid_user = [];
                        this.id_user = [];
                        this.dataid_user = Response.data.content.data;
                        this.dataid_user.forEach((item) => {
                            if (this.piuawal == item.user_id) {
                                this.selectedid_user = this.piuawal;
                                this.defaultSelectedid_user = {
                                    label: item.nama_satker,
                                    code: this.dataid_user.indexOf(item) + 1,
                                    tag: item.user_id,
                                };
                            }
                            this.id_user.push({
                                label: item.nama_satker,
                                code: this.dataid_user.indexOf(item) + 1,
                                tag: item.user_id,
                            });
                        });
                        this.id_user.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

        },
        onid_userChange(a) {
            try {
                this.selectedid_user = this.id_user[a].tag;
                this.piuawal = this.id_user[a].tag;
                this.halamanawal = 1;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        onlokasiChange(a) {
            try {
                this.selectedlokasi = this.lokasi[a].tag;
                this.lokasiawal = this.lokasi[a].tag;
                this.halamanawal = 1;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedlokasi);
            this.ambildata();
        },
        onjenispekerjaan2Change(a) {
            try {
                this.selectedjenispekerjaan2 = this.jenispekerjaan2[a].tag;
                this.kegiatanawal = this.jenispekerjaan2[a].tag;
                this.halamanawal = 1;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedjenispekerjaan2)
            this.ambildata();

            //alert(this.selectedjenispekerjaan2);
        },
        ontahunmulai2Change(a) {
            try {
                this.selectedtahunmulai2 = this.tahunmulai2[a].tag;
                this.tahunawal = this.tahunmulai2[a].tag;
                this.halamanawal = 1;
            }
            catch (err) {
                return;
            }
            this.ambildata();
        },
        onkomponenChange(a) {
            try {
                this.selectedkomponen = this.komponen[a].tag;
                this.komponenawal = this.komponen[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedkomponen)
            this.getsubkomponen();

            //alert(this.selectedkomponen);
        },
        onsubkomponenChange(a) {
            try {
                this.selectedsubkomponen = this.subkomponen[a].tag;
                this.subkomponenawal = this.subkomponen[a].tag;
                this.halamanawal = 1;
            }
            catch (err) {
                return;
            }
            this.ambildata();
            //alert(this.selectedsubkomponen)
            //this.rubahdatagrafik();

            //alert(this.selectedsubkomponen);
        },
        async getsubkomponen() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovationSubKomponen-GetProyekSubKomponen?random=" + random + "&project_id=" + this.project_id + "&komponen=" + this.selectedkomponen).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datasubkomponen = [];
                        this.subkomponen = [];
                        this.datasubkomponen = Response.data.content.data;
                        this.datasubkomponen.forEach((item) => {
                            this.subkomponen.push({
                                label: item.nama,
                                code: this.datasubkomponen.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.defaultSelectedsubkomponen = {
                            code: 0,
                            label: 'Semua Data',
                            tag: '',
                        };
                        this.subkomponen.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });
                    }
                    else {
                        this.datasubkomponen = [];
                        this.subkomponen = [];
                        this.defaultSelectedsubkomponen = {
                            code: 0,
                            label: 'Semua Data',
                            tag: '',
                        };
                        this.subkomponen.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
            this.halamanawal = 1;
            this.ambildata();
        },
        hapus(kode) {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Hapus Data?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#005c95",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Hapus"
            }).then((result) => {
                if (result.isConfirmed) {
                    const data = { kode: kode, project_id: this.project_id, deletedby: JSON.parse(localStorage.getItem("isistem")) }
                    const mainAPI = axios.create({
                        baseURL: process.env.VUE_APP_URL_API,
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                    });
                    var tambahan = "_" + this.halaman + "_" + this.selectedid_user + "_" + this.selectedjenispekerjaan2 + "_" + this.selectedtahunmulai2 + "_" + this.selectedlokasi + "_" + this.selectedkomponen + "_" + this.selectedsubkomponen + "_" + this.carikata;
                    //alert(this.halaman);
                    var bytes = encodeURIComponent(CryptoJS.AES.encrypt(kode + tambahan, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
                    //window.location.replace("/ProsesMonev/" + bytes);
                    mainAPI.post("parastapainnovationhapusmonev-HapusDataManualMonev", data).then(
                        Response => {
                            if (Response.data.response == 'error') {
                                swal.fire('Peringatan', Response.data.message, 'error');
                            }
                            else {
                                swal.fire('Informasi', 'Data telah dihapus..', 'success').then(function () {
                                    window.location.replace("/Monev/" + bytes);
                                });
                            }
                        }
                    ).catch(
                        error => {
                            swal.fire('Peringatan', 'Terjadi Kesalahan Format Data', 'error');
                        }
                    )

                }
            });
            return false;
        },
        async mappingemon(id, kodesatker, register) {
            this.halamanloading = true;
            this.kodeemon = [];
            this.carikodesatker = '';
            this.carikodesatker = kodesatker;
            this.idkegiatan = '';
            this.idkegiatan = id;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            //alert(this.idkegiatan);
            await mainAPI.get("detailkegiatan_emon-Kegiatan?random=" + random + "&project_id=" + this.project_id + "&id=" + this.idkegiatan
                + "&kode_satker=" + kodesatker + "&koderegister=" + register).then(
                    Response => {
                        this.datapesan = Response.data.message;
                        //alert(this.datapesan);
                        if (this.datapesan == 'data diketemukan') {
                            this.dataemon = [];
                            this.kodeemon = [];
                            this.dataemon = Response.data.content.data;
                            //console.log(this.dataemon);
                            for (let i = 0; i < this.dataemon.length; i++) {
                                if (this.dataemon[i].terpilih == 'true') {
                                    this.kodeemon.push(this.dataemon[i].kdgiat);
                                }
                            }
                            $('#costumModalpeta').modal('show');
                            this.halamanloading = false;
                        }
                        else {
                            this.dataemon = [];
                            this.halamanloading = false;
                        }

                    }
                ).catch(error => {
                    this.dataemon = [];
                    //console.log(error);
                    //this.ClearlocalStorage();
                    this.halamanloading = false;
                });

        },
        prosesdata(kode) {
            var tambahan = "_" + this.halaman + "_" + this.selectedid_user + "_" + this.selectedjenispekerjaan2 + "_" + this.selectedtahunmulai2 + "_" + this.selectedlokasi + "_" + this.selectedkomponen + "_" + this.selectedsubkomponen + "_" + this.carikata;
            //alert(this.halaman);
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt(kode + tambahan, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/ProsesDIPA/" + bytes);
        },
        proseskendala(kode) {
            var tambahan = "_" + this.halaman + "_" + this.selectedid_user + "_" + this.selectedjenispekerjaan2 + "_" + this.selectedtahunmulai2 + "_" + this.selectedlokasi + "_" + this.selectedkomponen + "_" + this.selectedsubkomponen + "_" + this.carikata;
            //alert(this.halaman);
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt(kode + tambahan, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/KendalaTindakLanjut/" + bytes);
        },
        prosesdatatarget(kode, mulai, selesai) {
            if (mulai == '0000-00-00' || selesai == '0000-00-00' || mulai == '' || selesai == '' || mulai == null || selesai == null) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Isikan Tanggal Mulai Dan Selesai Kontrak Terlebih Dahulu..',
                });
                return false;
            }
            var tambahan = "_" + this.halaman + "_" + this.selectedid_user + "_" + this.selectedjenispekerjaan2 + "_" + this.selectedtahunmulai2 + "_" + this.selectedlokasi + "_" + this.selectedkomponen + "_" + this.selectedsubkomponen + "_" + this.carikata;
            //alert(this.halaman);
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt(kode + tambahan, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/ProsesKurvaS/" + bytes);
        },
        prosesspm(kode) {
            var tambahan = "_" + this.halaman + "_" + this.selectedid_user + "_" + this.selectedjenispekerjaan2 + "_" + this.selectedtahunmulai2 + "_" + this.selectedlokasi + "_" + this.selectedkomponen + "_" + this.selectedsubkomponen + "_" + this.carikata;
            //alert(this.halaman);
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt(kode + tambahan, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/ProsesSPM/" + bytes);
        },
        onChange_old(event) {
            this.tempjumlahdb = 0;
            try {
                if (event.target.files[0]['type'] == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                    this.file = event.target.files ? event.target.files[0] : null;
                    if (this.file) {
                        this.tempheader = [];
                        this.tempdata = [];
                        readXlsxFile(this.file).then((rows) => {
                            // `rows` is an array of rows
                            // each row being an array of cells.
                            //alert(rows.length);
                            this.halamanloading = true;
                            this.tempjumlah = rows.length - 1;
                            //alert(this.tempjumlah);
                            for (let i = 0; i < rows.length; i++) {
                                this.halamanloading = true;
                                if (i == 0) {
                                    var varheader = rows[i];
                                    for (let x = 0; x < varheader.length; x++) {
                                        this.tempheader.push(varheader[x]);
                                    }
                                }
                                else {
                                    this.tempdata.push(rows[i]);
                                }
                                document.getElementById('persennyafilenya_excel').style.width = Math.round((i / (rows.length - 1)) * 100) + "%";
                                document.getElementById('tulisanpersenfilenya_excel').innerHTML = Math.round((i / (rows.length - 1)) * 100) + "%";
                            }
                            //alert(JSON.stringify(this.tempheader));
                            //console.log(this.tempdata);
                            this.halamanloading = false;
                        })
                    }
                }
                else {
                    swal.fire('Peringatan', 'File tidak sesuai format', 'error');
                    return false;
                }
            } catch (error) {

            }

        },
        async uploadsavedata() {
            //alert(JSON.stringify(this.tempheader));
            //alert(JSON.stringify(this.tempdata));
            var tempheader = this.tempheader;
            //console.log(JSON.stringify(this.tempdata));
            //alert(this.tempdata.length);
            //return false;
            var temparraydata = ''
            for (let i = 0; i < this.tempdata.length; i++) {
                var data = "";
                for (let x = 0; x < this.tempdata[i].length; x++) {
                    if (x == 0) {
                        data = this.tempdata[i][x];
                    }
                    else {
                        data = data + '|' + this.tempdata[i][x];
                    }
                }
                if (i == 0) {
                    temparraydata = temparraydata + data;
                }
                else {
                    temparraydata = temparraydata + '|+|' + data;
                }
            }
            //console.log(JSON.stringify(tempheader));
            //console.log(temparraydata);
            //return false;

            var fd = new FormData();
            fd.append("tempheader", tempheader);
            fd.append("data", temparraydata);
            fd.append("project_id", this.project_id);
            fd.append("kolom", 'STATUSPROYEK');
            fd.append("tabel", 'zpartial_pmc_master_f_dan_k');
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            this.halamanloading = true;
            await mainAPI.post("parastapainnovation_excelQSmonev-SaveQSExcel", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        this.halamanloading = false;
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        this.halamanloading = false;
                        swal.fire('Informasi', 'Data telah diimport..', 'success').then(function () {
                            window.location.replace("/Monev");
                        });

                    }
                }
            ).catch(function (error) {
                //this.halamanloading = false;
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )

        },
        onChange(event) {
            this.tempjumlahdb = 0;
            try {
                if (event.target.files[0]['type'] == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                    this.file = event.target.files ? event.target.files[0] : null;
                    if (this.file) {
                        this.tempheader = [];
                        this.tempdata = [];
                        readXlsxFile(this.file).then((rows) => {
                            // `rows` is an array of rows
                            // each row being an array of cells.
                            //alert(rows.length);
                            this.halamanloading = true;
                            this.tempjumlah = rows.length - 1;
                            //alert(this.tempjumlah);
                            for (let i = 0; i < rows.length; i++) {
                                this.halamanloading = true;
                                if (i == 0) {
                                    var varheader = rows[i];
                                    for (let x = 0; x < varheader.length; x++) {
                                        this.tempheader.push(varheader[x]);
                                    }
                                }
                                else {
                                    this.tempdata.push(rows[i]);
                                }
                                document.getElementById('persennyafilenya_excel').style.width = Math.round((i / (rows.length - 1)) * 100) + "%";
                                document.getElementById('tulisanpersenfilenya_excel').innerHTML = Math.round((i / (rows.length - 1)) * 100) + "%";
                            }
                            //alert(JSON.stringify(this.tempheader));
                            //console.log(this.tempdata);
                            this.halamanloading = false;
                        })
                    }
                }
                else {
                    swal.fire('Peringatan', 'File tidak sesuai format', 'error');
                    return false;
                }
            } catch (error) {

            }
        },
        async uploadsavedata_old() {
            this.tempjumlahdb = 0;
            var tempheader = this.tempheader;
            //console.log(JSON.stringify(this.tempdata));
            //alert(this.tempdata.length);
            //return false;
            var temparraydata = ''
            for (let i = 0; i < this.tempdata.length; i++) {
                var data = "";
                for (let x = 0; x < this.tempdata[i].length; x++) {
                    if (x == 0) {
                        data = this.tempdata[i][x];
                    }
                    else {
                        data = data + '|' + this.tempdata[i][x];
                    }
                }
                if (i == 0) {
                    temparraydata = temparraydata + data;
                }
                else {
                    temparraydata = temparraydata + '|+|' + data;
                }
            }
            //console.log(temparraydata);
            //return false;
            var fd = new FormData();
            fd.append("tempheader", tempheader);
            fd.append("data", temparraydata);
            fd.append("project_id", this.project_id);
            fd.append("kolom", 'STATUSPROYEK');
            fd.append("tabel", 'zpartial_pmc_master_f_dan_k');
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            this.halamanloading = true;
            await mainAPI.post("parastapainnovation_excelmonev-SaveExcel", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        this.halamanloading = false;
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        this.halamanloading = false;
                        swal.fire('Informasi', 'Data telah diimport..', 'success').then(function () {
                            window.location.replace("/Monev");
                        });

                    }
                }
            ).catch(function (error) {
                //this.halamanloading = false;
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            //alert(tempheader);
            //alert(acuan);
            //alert(data);
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
        },
        onChangeHalaman(event) {
            this.pindahhalaman(event.target.value);
        },
        async pindahhalaman(halamannya) {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            this.halamanawal = halamannya;
            if (this.piuawal != '' && this.selectedid_user != this.piuawal && this.selectedid_user == '') {
                this.selectedid_user = this.piuawal;
            }
            else {
                this.selectedid_user = this.selectedid_user;
            }

            if (this.kegiatanawal != '' && this.selectedjenispekerjaan2 != this.kegiatanawal && this.selectedjenispekerjaan2 == '') {
                this.selectedjenispekerjaan2 = this.kegiatanawal;
            }
            else {
                this.selectedjenispekerjaan2 = this.selectedjenispekerjaan2;
            }

            if (this.tahunawal != '' && this.selectedtahunmulai2 != this.tahunawal && this.selectedtahunmulai2 == '') {
                this.selectedtahunmulai2 = this.tahunawal;
            }
            else {
                this.selectedtahunmulai2 = this.selectedtahunmulai2;
            }

            if (this.lokasiawal != '' && this.selectedlokasi != this.lokasiawal && this.selectedlokasi == '') {
                this.selectedlokasi = this.lokasiawal;
            }
            else {
                this.selectedlokasi = this.selectedlokasi;
            }

            if (this.komponenawal != '' && this.selectedkomponen != this.komponenawal && this.selectedkomponen == '') {
                this.selectedkomponen = this.komponenawal;
            }
            else {
                this.selectedkomponen = this.selectedkomponen;
            }

            if (this.subkomponenawal != '' && this.selectedsubkomponen != this.subkomponenawal && this.selectedsubkomponen == '') {
                this.selectedsubkomponen = this.subkomponenawal;
            }
            else {
                this.selectedsubkomponen = this.selectedsubkomponen;
            }

            if (this.carikataawal != '' && this.carikata != this.carikataawal && this.carikata == '') {
                this.carikata = this.carikataawal;
            }
            else {
                this.carikata = this.carikata;
            }

            this.secretencData = halamannya + "_" + this.selectedid_user + "_" + this.selectedjenispekerjaan2 + "_" + this.selectedtahunmulai2 + "_" + this.selectedlokasi + "_" + this.selectedkomponen + "_" + this.selectedsubkomponen + "_" + this.carikataawal;
            await mainAPI.get("parastapainnovationmonev-GetMonev?random=" + random + "&project_id="
                + this.project_id + "&halaman=" + halamannya + "&nama=" + this.carikata
                + "&id_user=" + this.levelinstansi + "&role=" + this.roleuser
                + "&lokasi=" + this.selectedlokasi + "&jenispekerjaan=" + this.selectedjenispekerjaan2
                + "&tahun=" + this.selectedtahunmulai2 + "&komponen="
                + this.selectedkomponen + "&subkomponen=" + this.selectedsubkomponen + "&idpiu=" + this.selectedid_user
                + "&lokasi=" + this.selectedlokasi).then(
                    Response => {
                        this.datapesan = Response.data.message;
                        this.colspan = 0;
                        this.datatahun = [];
                        this.colspan = Response.data.jumlahtahun;
                        this.datatahun = Response.data.tahun;
                        //alert(this.datapesan);
                        if (this.datapesan == 'data diketemukan') {
                            this.datamaster = [];
                            this.datamaster = Response.data.content.data;
                            this.jumlahdata = Response.data.content.jumlahdata;
                            this.jumlahhalaman = Response.data.content.jumlahhalaman;
                            this.mulai = Response.data.content.mulai;
                            if (this.mulai == 0) {
                                this.halaman = 1;
                            }
                            else {
                                this.halaman = (this.mulai / 20) + 1;
                            }
                        }
                        else {
                            this.datamaster = [];
                            this.jumlahdata = 0;
                            this.jumlahhalaman = 0;
                            this.mulai = 0;
                        }
                        this.halamanloading = false;
                    }
                ).catch(error => {
                    //console.log(error);
                    //this.ClearlocalStorage();
                    this.halamanloading = false;
                });
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            //alert(this.halamanawal);
            //(this.halaman);


            if (this.piuawal != '' && this.selectedid_user != this.piuawal && this.selectedid_user == '') {
                this.selectedid_user = this.piuawal;
                this.halaman = 1;
            }
            else {
                this.selectedid_user = this.selectedid_user;
                this.halaman = 1;
            }

            if (this.kegiatanawal != '' && this.selectedjenispekerjaan2 != this.kegiatanawal && this.selectedjenispekerjaan2 == '') {
                this.selectedjenispekerjaan2 = this.kegiatanawal;
                this.halaman = 1;
            }
            else {
                this.selectedjenispekerjaan2 = this.selectedjenispekerjaan2;
                this.halaman = 1;
            }

            if (this.tahunawal != '' && this.selectedtahunmulai2 != this.tahunawal && this.selectedtahunmulai2 == '') {
                this.selectedtahunmulai2 = this.tahunawal;
                this.halaman = 1;
            }
            else {
                this.selectedtahunmulai2 = this.selectedtahunmulai2;
                this.halaman = 1;
            }

            if (this.lokasiawal != '' && this.selectedlokasi != this.lokasiawal && this.selectedlokasi == '') {
                this.selectedlokasi = this.lokasiawal;
                this.halaman = 1;
            }
            else {
                this.selectedlokasi = this.selectedlokasi;
                this.halaman = 1;
            }

            if (this.komponenawal != '' && this.selectedkomponen != this.komponenawal && this.selectedkomponen == '') {
                this.selectedkomponen = this.komponenawal;
                this.halaman = 1;
            }
            else {
                this.selectedkomponen = this.selectedkomponen;
                this.halaman = 1;
            }

            if (this.subkomponenawal != '' && this.selectedsubkomponen != this.subkomponenawal && this.selectedsubkomponen == '') {
                this.selectedsubkomponen = this.subkomponenawal;
                this.halaman = 1;
            }
            else {
                this.selectedsubkomponen = this.selectedsubkomponen;
                this.halaman = 1;
            }

            if (this.carikataawal != '' && this.carikata != this.carikataawal && this.carikata == '') {
                this.carikata = this.carikataawal;
                this.halaman = 1;
            }
            else {
                this.carikata = this.carikata;
                this.halaman = 1;
            }

            if (this.halamanawal != this.halaman) {
                this.halaman = this.halamanawal;
            }

            this.secretencData = this.halaman + "_" + this.selectedid_user + "_" + this.selectedjenispekerjaan2 + "_" + this.selectedtahunmulai2 + "_" + this.selectedlokasi + "_" + this.selectedkomponen + "_" + this.selectedsubkomponen + "_" + this.carikataawal;

            await mainAPI.get("parastapainnovationfinance-GetFinance?random=" + random + "&project_id=" + this.project_id + "&nama=" + this.carikata
                + "&id_user=" + this.levelinstansi + "&role=" + this.roleuser + "&idpiu=" + this.selectedid_user
                + "&lokasi=" + this.selectedlokasi + "&jenispekerjaan=" + this.selectedjenispekerjaan2 + "&tahun=" + this.selectedtahunmulai2 + "&komponen="
                + this.selectedkomponen + "&subkomponen=" + this.selectedsubkomponen + "&halaman=" + this.halaman
                + "&lokasi=" + this.selectedlokasi).then(
                    Response => {
                        this.datapesan = Response.data.message;
                        this.colspan = 0;
                        this.datatahun = [];
                        this.colspan = Response.data.jumlahtahun;
                        this.datatahun = Response.data.tahun;
                        //alert(this.datapesan);
                        if (this.datapesan == 'data diketemukan') {
                            this.datamaster = [];
                            this.datamaster = Response.data.content.data;
                            this.jumlahdata = Response.data.content.jumlahdata;
                            this.jumlahhalaman = Response.data.content.jumlahhalaman;
                            this.mulai = Response.data.content.mulai;
                            if (this.mulai == 0) {
                                this.halaman = 1;
                            }
                            else {
                                this.halaman = (this.mulai / 20) + 1;
                            }
                            this.halamanloading = false;
                        }
                        else {
                            this.datamaster = [];
                            this.jumlahdata = 0;
                            this.jumlahhalaman = 0;
                            this.mulai = 0;
                            this.halamanloading = false;
                        }

                    }
                ).catch(error => {
                    //console.log(error);
                    //this.ClearlocalStorage();
                    this.halamanloading = false;
                });
        },
    },
    mounted() {
        //alert(this.secretencData);
        var tmp = this.secretencData.split("_");
        this.halamanawal = tmp[1];
        this.piuawal = tmp[2];
        this.kegiatanawal = tmp[3];
        this.tahunawal = tmp[4];
        this.lokasiawal = tmp[5];
        this.komponenawal = tmp[6];
        this.subkomponenawal = tmp[7];
        this.carikataawal = tmp[8];
        if (tmp[8] != '') {
            this.carikata = tmp[8];
        }

        this.getOtentifikasi();
        this.ambildatareff();
        this.ambildata();
        this.ambildata();

    }
}
</script>
<style></style>